import React, { Component } from 'react'
import {
  CardElement,
  injectStripe
} from 'react-stripe-elements';
import FlatButton from 'material-ui/FlatButton'
import { FormattedMessage } from 'react-intl'
import { ALertHeaderText } from '../../../components/Seminars/styles'
import IconButton from 'material-ui/IconButton'
import Clear from 'material-ui/svg-icons/content/clear'

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        fontFamily: 'Open Sans, sans-serif',
        letterSpacing: '0.025em',
        '::placeholder': {
          color: '#aab7c4',
        },
        marginBottom: '20px'
      },
      invalid: {
        color: '#c23d4b',
      },
    }
  }
};

class UpdateStripeCard extends Component {
  state = {
    errorMessage: ''
  }

  handleChangeToken = ({error}) => {
    if (error) {
      this.setState({errorMessage: error.message});
    } else {
      this.setState({errorMessage: ''});
    }
  };

  stripeTokenHandler = async (stripeResponse) => {
    if (stripeResponse.error){
      this.setState({errorMessage: stripeResponse.error.message});
      return
    } else {
      await this.props.onToken(stripeResponse.token);
    }
  }

  handleSubmit = (evt) => {
    evt.preventDefault();
    if (this.props.stripe && this.state.errorMessage === '') {
      this.props.stripe.createToken().then(this.stripeTokenHandler);
    } else {
      console.log("Stripe.js hasn't loaded yet.");
    }
  }

  render() {
    return (
      <div>
        <div className="flex justify-between items-center mb3">
          <ALertHeaderText>
            <FormattedMessage id="user.updateCard"/>
          </ALertHeaderText>
          <div>
            <IconButton
                onTouchTap={this.props.handleClose}
                iconStyle={{fill: '#afb8c5'}}>
                <Clear/>
            </IconButton>
          </div>
        </div>
        <div className="CardDemo">
            <form onSubmit={this.handleSubmit.bind(this)}>
            <div className="mb2">
                <div style={{margin: '20px 0px'}}>
                <CardElement
                    onChange={this.handleChangeToken}
                    {...createOptions()}
                    hidePostalCode={true}
                />

                <div className="error" role="alert">
                    {this.state.errorMessage}
                </div>
                </div>

            </div>

            <div className="flex justify-end">
                <div className="w4">
                <FlatButton
                    label={
                    <FormattedMessage id="loggedInNavigation.cancel"/>
                    }
                    fullWidth
                    labelStyle={{color: '#AFB8C4'}}
                    onTouchTap={this.props.handleClose}
                />
                </div>

                <div className="w4">
                <FlatButton
                    label={
                      <FormattedMessage id="CreateDomainLabel.submit"/>
                    }
                    type="submit"
                    fullWidth
                    style={{padding: 0}}
                    hoverColor="#1e8257"
                    backgroundColor="#29B87A"
                    labelStyle={{color: '#FFFFFF'}}
                />
                </div>
            </div>
            </form>
        </div>
      </div>
    );
  }
}

export default injectStripe(UpdateStripeCard) 



// WEBPACK FOOTER //
// src/routes/ManagePlans/Plans/UpdateStripeCard.js